import { push } from 'react-router-redux';
import service from '../utility/service';
import { errorOccurred } from '../errors/reducer';

const INITIAL_STATE = {
  fetching: false,
  current: undefined
};

const types = {
  FETCHING_CURRENT: 'orb/legal/FETCHING_CURRENT',
  RECEIVED_CURRENT: 'orb/legal/RECEIVED_CURRENT',
};

export default function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case types.FETCHING_CURRENT:
      return Object.assign({}, state, {
        fetching: true
      });
    case types.RECEIVED_CURRENT:
      return Object.assign({}, state, {
        fetching: false,
        current: action.user
      });
    default:
      return state;
  }
}
reducer.types = types;
reducer.initialState = INITIAL_STATE;

function fetchingCurrentUser() {
  return {
    type: types.FETCHING_CURRENT
  };
}

function receivedCurrentUser(user) {
  return {
    type: types.RECEIVED_CURRENT,
    user
  };
}

function fetchCurrentUser() {
  return (dispatch) => {
    dispatch(fetchingCurrentUser());

    return service.get('/CurrentUser').then((response) => {
      if (!response.data.CanView && response.data.CanAdminister) {
        dispatch(push('/admin'));
      }
      dispatch(receivedCurrentUser(response.data));
    }).catch((err) => {
      dispatch(errorOccurred(err, 'Getting current user'));
    });
  };
}

function shouldFetchCurrentUser(state) {
  return !state.current && !state.fetching;
}

export function fetchCurrentUserIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchCurrentUser(getState().user)) {
      return dispatch(fetchCurrentUser());
    }
    return Promise.resolve();
  };
}



// WEBPACK FOOTER //
// ./src/user/reducer.js